export default __webpack_public_path__ + "static/media/check-solid.26b75326.svg";